import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/comm/Navbar';
import Header from '../../../components/comm/Head';
import style from './TotalMenu.module.css';
import URL from '../../../constants/url';
import { Link } from "react-router-dom";
import totalMenuData from '../../../assets/json/totalMenu.json';

//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const TotalMenu = () => {

    const navigate = useNavigate();
    const [hospInfoList, setHospInfoList] = useState([]);     // 병원 리스트 
    const [searchKeyword, setSearchKeyword] = useState("");   // 키워드
    const [changeMenuBox, setChangeMenuBox] = useState(1);    // 메뉴박스 체인지
    const [recentSearches, setRecentSearches] = useState(() => {
        const stored = sessionStorage.getItem('recentSearches');
        return stored ? JSON.parse(stored) : [];
    });
    
    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

    //추천 검색어 
    const recommendedKeywords = ['진료 예약', '병원 정보', '건강 정보'];

    //Accordion
    const [expanded, setExpanded] = React.useState('panel0');

    const acHandleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(()=>{
        loginUser.usrHsptlMap.map((item, index) => {
            if(item.hsptlSortOrdr === 1){
                setExpanded(`panel${item.cnncHsptlCd}`);
            }
        });
    }, [])


    // input focus
    const handleFocusOn = () => {
        setChangeMenuBox(2);
    };

    const handleChangeOn = (event) => {
        const keyword = event.target.value;
        setChangeMenuBox(keyword ? 3 : 2);
        setSearchKeyword(keyword);
    }

    // 환자 병원코드 가지고 오기
    useEffect(()=> {
        
        try {
            const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));
            if (loginUser) {
                setHospInfoList(loginUser.usrHsptlMap || []);
            }
        } catch (e) {
            console.error('세션스토리지 파싱 에러:', e);
        }
    },[]); 

    // 검색 매칭 함수 추가 (공백 무시 비교)
    const normalizeText = (text) => text?.toLowerCase().replace(/\s/g, '') || '';

    const matchesKeyword = (text, keyword) => {
        if (!text || !keyword) return false;
        return normalizeText(text).includes(normalizeText(keyword));
    };


    //검색
   const getFilteredResults = () => {
            const keyword = searchKeyword.toLowerCase();

            const homeCare = [];
            const hospCare = [];
            const alarm = [];
            const myInfo = [];

            totalMenuData.forEach((item) => {
                item.secondMenu.forEach((second) => {
                    const isHospitalMenu = !!second.thirdMenu;
                    const isUserHospital = hospInfoList.some(hosp => hosp.cnncHsptlCd === second.hosptCd);

                    if (isHospitalMenu) {
                        // 병원 케어
                        if (!isUserHospital) return;

                        const hospitalNameMatched = second.secondNm?.toLowerCase().includes(keyword);
                        const matchedThird = second.thirdMenu
                        .filter(third => matchesKeyword(third.thirdNm, keyword))
                        .map(third => ({
                            thirdNm: third.thirdNm,
                            linkUrl: third.linkUrl
                        }));


                        if (hospitalNameMatched || matchedThird.length > 0) {
                            hospCare.push({
                                hospitalNm: second.secondNm,
                                hosptCd: second.hosptCd,
                                thirdMatches: matchedThird.length > 0 ? matchedThird : []
                            });
                        }
                    } else {
                        // 일반 메뉴 (앱 설정, 홈 케어, 내 정보 등)
                         if (matchesKeyword(second.secondNm, keyword)) {
                            const code = item.bsnSeCd;
                            const matchedItem = {
                                secondNm: second.secondNm,
                                linkUrl: second.linkUrl,
                            };

                            if (code === 'HOME') homeCare.push(matchedItem);
                            else if (code === 'MYPAGE') myInfo.push(matchedItem);
                            else if (code === 'NOTI') alarm.push(matchedItem);
                            else homeCare.push(matchedItem);
                        }
                    }
                });
            });

            return { homeCare, hospCare, alarm, myInfo };
            
        };


    const highlightMatch = (text, keyword) => {
        if (!text || !keyword) return text;

        // 키워드의 각 글자 사이에 공백 허용하는 정규식 생성
        const escapedKeyword = keyword.replace(/\s/g, '').split('').map(c =>
            c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        ).join('\\s*');

        const regex = new RegExp(`(${escapedKeyword})`, 'gi');
        const parts = text.split(regex);

        return (
            <>
                {parts.map((part, i) =>
                    regex.test(part)
                        ? <b key={i}>{part}</b>
                        : <span key={i}>{part}</span>
                )}
            </>
        );
    };



    const handleSearchChange = (keyword) => {
        setSearchKeyword(keyword);
        setChangeMenuBox(3); // 검색어 입력 상태로 전환

        // 최근 검색어에 추가 (중복 제거 및 최대 5개 유지)
        setRecentSearches(prev => {
            const filtered = prev.filter(item => item !== keyword);
            const newList = [keyword, ...filtered].slice(0, 5);
            sessionStorage.setItem('recentSearches', JSON.stringify(newList));
            return newList;
        });
    };

    const handleDeleteRecent = (keyword) => {
        setRecentSearches(prev => {
            const newList = prev.filter(item => item !== keyword);
            sessionStorage.setItem('recentSearches', JSON.stringify(newList));
            return newList;
        });
    };

    const getHsptlPatntNo = (hsptlCd) => {
        const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));
        const result = loginUser.usrHsptlMap.find(item => item.cnncHsptlCd === hsptlCd);
        return result.cnncPatntNo;
    }

    return (
        <>
            <Header menu="totalmenu" />

            <div className="container" data-type='a'>

                {/* 검색::S */}
                <div className={style['search-wrap']}  data-active={changeMenuBox != 1 ? "on" : null} >
                    <div className={style['search-box']}>
                        <input 
                            type="text" 
                            placeholder='검색어를 입력해주세요'
                            value={searchKeyword}
                            onFocus={handleFocusOn}
                            onChange={(e) => {
                                setSearchKeyword(e.target.value);
                                handleChangeOn(e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && searchKeyword.trim()) {
                                handleSearchChange(searchKeyword.trim());
                                }
                            }}
                        />
                         <button className={style['search-btn']}></button>
                    </div>

                    {changeMenuBox != 1 ? 
                    (<button 
                        className={style['cancel-btn']} 
                        onClick={()=> {
                            setChangeMenuBox(1)
                            setSearchKeyword('');
                            }
                        }> 
                        <span>취소</span> 
                    </button>) : null 
                    }
                    

                </div>
                {/* 검색::E */}



                    {/* 전체메뉴::S */}
                    {changeMenuBox === 1 ? (
                         <div className='inner-wrap'>   
                            <div className={style['menu-lists']}>

                            <ul className={style['first-menu']}>

                                {totalMenuData.map((items, index) => (
                                    <li key={index}>
                                        <h2 className='h2'>{items.menuNm}</h2>

                                            {items.bsnSeCd === "HOSP" ? (
                                                <>
                                                    <ul>
                                                        <li>
                                                            <div className={style['third-menu']}>
                                                                <div className="accordion-wrap" data-type="c" data-cont="menu-list">
                                                                    {
                                                                        hospInfoList.map((item, index)=>(
                                                                            items.secondMenu.map((subItem, subIndex)=>{
                                                                                if(item.cnncHsptlCd === subItem.hosptCd){
                                                                                    return (
                                                                        <Accordion 
                                                                            key={subItem.hosptCd} 
                                                                            expanded={expanded === `panel${subItem.hosptCd}`} 
                                                                            onChange={acHandleChange(`panel${subItem.hosptCd}`)}>
                                                                            <AccordionSummary
                                                                                expandIcon={<ExpandMoreIcon />}
                                                                            >
                                                                                <div className="accordion-head">
                                                                                    <p className="tit">
                                                                                    {subItem.secondNm}
                                                                                    </p>
                                                                                </div>
                                                                            </AccordionSummary>

                                                                            <AccordionDetails>
                                                                                <div className="accordion-body">
                                                                                    <ul className={style['third-menu-list']}>
                                                                                        {subItem.thirdMenu.map((thirdItem, indexs) => (
                                                                                            <li key={indexs}>
                                                                                                <Link 
                                                                                                    to={URL[thirdItem.linkUrl]} state={{ 
                                                                                                            hsptlCd : subItem.hosptCd   ,
                                                                                                            hsptlNm : subItem.secondNm  ,
                                                                                                            patntId : getHsptlPatntNo(subItem.hosptCd) ,
                                                                                                            resvOpen : thirdItem.linkUrl === "HOSPITAL_HOME" ? "true" : ""
                                                                                                        }} 
                                                                                                    draggable={false}
                                                                                                >
                                                                                                {thirdItem.thirdNm}
                                                                                                </Link>
                                                                                            </li>    
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </AccordionDetails>

                                                                        </Accordion>

                                                                                    )
                                                                                }
                                                                            })
                                                                        ))
                                                                    }
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                </>
                                            ):
                                                <ul className={style['second-menu']}>
                                                    {items.secondMenu.map ((subItem, subIndex) => (
                                                        <li key={subIndex}>
                                                            <Link 
                                                                to={URL[subItem.linkUrl]}
                                                                draggable={false}    
                                                                >
                                                                {subItem.secondNm}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            } 
                                        
                                    </li>  
                                    
                                ))}
                            </ul>

                            {/* 약국찾기 앱 테스트 */}
                            <button className='hide-test' onClick={()=> navigate(URL.HOSPITAL_PHARMACYFIND)}>
                                <span>약국 찾기</span>
                            </button>
                            </div>
                        </div> 
                    ) : null }
                    {/* 전체메뉴::E */}



                    {/* 검색창 활성화::S */}
                    {changeMenuBox === 2 ? (    
                        <div className='inner-wrap' data-padding="0">   
                            <div className={style['search-guide-box']}>
                                
                                <div className={style['recommed-search-box']}>
                                    <p>추천 검색어</p>
                                    <div className={style['scroll-box']}>
                                        <ul>
                                            {recommendedKeywords.map((keyword, i) => (
                                                <li 
                                                    key={i} 
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => handleSearchChange(keyword)}
                                                >
                                                    {keyword}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    
                                </div>

                                {recentSearches.length > 0 && (
                                    <div className={style['latest-search-box']}>
                                        <p>최근 검색어</p>
                                        <ul>
                                        {recentSearches.map((keyword, i) => (
                                            <li key={i}>
                                            <span 
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleSearchChange(keyword)}
                                            >
                                                {keyword}
                                            </span>
                                            <button 
                                                className={style['delete-btn']} 
                                                onClick={() => handleDeleteRecent(keyword)}
                                                aria-label="최근 검색어 삭제"
                                            />
                                            </li>
                                        ))}
                                        </ul>
                                    </div>
                                )}

                            </div>
                        </div>
                    ): null }   
                    {/* 검색창 활성화::E */}


                    {/* 검색창 onChange::S */}
                    {changeMenuBox === 3 && (
                        (() => {
                            const { homeCare, hospCare, alarm, myInfo } = getFilteredResults();
                            

                            if (
                                homeCare.length === 0 &&
                                hospCare.length === 0 &&
                                alarm.length === 0 &&
                                myInfo.length === 0 
                            ) {
                                return (
                                    <div className={style['no-search-data-box']}>
                                        <div className={style['top-box']}>
                                            <p>검색 결과가 없습니다</p>
                                        </div>
                                        <div className={style['bot-box']}>
                                            <span>추천 검색어</span>
                                            <ul className={style['search-item']}>
                                                {recommendedKeywords.map((keyword, i) => (
                                                    <li 
                                                        key={i} 
                                                        style={{cursor: 'pointer'}}
                                                        onClick={() => handleSearchChange(keyword)}
                                                    >
                                                       <button>{keyword}</button> 
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                );
                            }

                            return (
                                <div className={style['search-auto-box']}>
                                    {homeCare.length > 0 && (
                                        <div className={style['conts-box']}>
                                            <strong>홈 케어</strong>
                                            <ul>
                                                {homeCare.map((item, i) => (
                                                    <li key={i}>
                                                        <Link to={URL[item.linkUrl]} draggable={false}>
                                                            <p>{highlightMatch(item.secondNm, searchKeyword)}</p>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {hospCare.length > 0 && (
                                        <div className={style['conts-box']}>
                                            <strong>병원 케어</strong>
                                            <ul>
                                                {hospCare.map((item, i) => (
                                                    <li key={i}>
                                                        <p>{highlightMatch(item.hospitalNm, searchKeyword)}</p>
                                                        {item.thirdMatches.length > 0 && item.thirdMatches.map((third, j) => (
                                                            <p key={j}>
                                                                <Link to={URL[third.linkUrl]} state={{ hsptlCd: item.hosptCd }} draggable={false}>
                                                                    {highlightMatch(third.thirdNm, searchKeyword)}
                                                                </Link>
                                                            </p>
                                                        ))}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {alarm.length > 0 && (
                                        <div className={style['conts-box']}>
                                            <strong>알림 센터</strong>
                                            <ul>
                                                {alarm.map((item, i) => (
                                                   <li key={i}>
                                                        <Link to={URL[item.linkUrl]} draggable={false}>
                                                            <p>{highlightMatch(item.secondNm, searchKeyword)}</p>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                    {myInfo.length > 0 && (
                                        <div className={style['conts-box']}>
                                            <strong>내 정보</strong>
                                            <ul>
                                                {myInfo.map((item, i) => (
                                                    <li key={i}>
                                                        <Link to={URL[item.linkUrl]} draggable={false}>
                                                            <p>{highlightMatch(item.secondNm, searchKeyword)}</p>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            );
                        })()
                    )}
  
                    {/* 검색창 onChange::E */}
                


                

            </div>

            <Navbar />
            
        </>
    );
};

export default TotalMenu;
